import styled from 'styled-components';
import * as FiIcons from 'react-icons/fi';

export const Container = styled.div`
  display: flex;
  flex-flow: row wrap;
  justify-content: center;
`;

export const TableContainer = styled.div`
  margin-top: 2.5%;
  max-width: 100%;
  min-width: 100%;
`;

export const RightHeaderContainer1 = styled.div``;

export const RightContainer = styled.div`
  min-height: 834px;
  background-color: #ffffff;

  border-radius: 4px;
  padding: 10px 30px 30px 30px;
  width: 52%;
`;

export const LeftContainer = styled.div`
  width: max-content;
  height: 40%;
  margin-right: 30px;
`;

export const BenefitsContainer = styled.div`
  background-color: white;
  padding: 10px 30px 30px 30px;
  border-radius: 4px;
  margin-top: 30px;
  min-height: 585px;
`;

export const PayHistoryContainer = styled.div`
  background-color: white;
  border-radius: 4px;
  padding: 10px 30px 30px 30px;
`;

export const PayHistoryColumnContainer = styled.div`
  display: flex;
  flex-direction: row;
  gap: 10px;
`;

export const PaystubIcon = styled.img`
  width: auto;
  height: 35px;
`;

export const HeaderContainer = styled.div`
  display: flex;
  height: max-content;
  align-items: center;
  justify-content: space-between;
  @media (max-width: 1500px) {
    flex-direction: column;
  }
`;

export const PayHistoryRedirectButton = styled.div`
  display: flex;
  width: 210px;
  height: 139px;
  flex-direction: column;
  font: normal normal normal 16px Biotif;
  letter-spacing: 0px;
  color: #ffffff;
  border-radius: 7px;
  align-items: center;
  justify-content: center;
  background: #4948ac 0% 0% no-repeat padding-box;
  &:hover {
    background-color: #2dcaff;
    transition: 0.75s;
  }
`;

export const HiddenBtn = styled.button`
  background-color: inherit;
  width: max-content;
  height: max-content;
  border: none;
`;

export const EyeIcon = styled(FiIcons.FiEye)`
  width: 25px;
  height: 45px;
`;

export const EyeIconButton = styled.button`
  cursor: pointer;
  border: 0px white solid;
  background: rgba(0, 0, 0, 0);
`;

export const PaystubText = styled.p`
  text-align: center;
  letter-spacing: 0px;
  color: #ffffff;
  padding: 0;
  margin: 0.5em;
  font-size: 1.6rem;
  font-family: Biotif, sans-serif;
  text-align: center;
`;

export const PayHistoryQuantity = styled.div`
  display: flex;
  width: 210px;
  height: 139px;
  flex-direction: column;
  background: #ffffff 0% 0% no-repeat padding-box;
  box-shadow: 0px 3px 16px #00000029;
  border-radius: 7px;
  align-items: center;
  justify-content: center;
`;

export const PaystubQuantityNumberText = styled.p`
  color: #222247;
  line-height: 5.8rem;
  font: normal bold 5.8rem/1 Biotif;
  padding: 0;
  margin: 0;
  text-align: center;
`;

export const PaystubQuantityText = styled.p`
  text-align: center;
  font: normal normal normal 1.6rem Biotif;
  letter-spacing: 0px;
  color: #222247;
  padding: 0;
  margin: 0;
`;

export const SubHeaderText = styled.h4`
  color: #707070;
  font-family: Biotif, sans-serif;
`;
